import React, { useEffect, useState } from 'react';
import { currencyValue, FormatDate, kgValue } from '../../../../../Utils/renderField/hookForms';
import { calcularBonoFletes } from '../../../Utils/BonificacionRecepciones';
import TotalesBonificacion from '../../../../../Utils/Components/TotalesBonificacion';
import '../RecepcionesBonificacion.css';

/**
 * Componente que muestra la tabla de recepciones y bonificaciones por costo de flete
 * @param {Object} props - Props del componente
 * @param {Array} props.recepciones - Array de recepciones
 * @param {number} props.cambio_dolar - Tasa de cambio del dolar
 * @returns {JSX.Element} - Componente RecepcionesFletes
 */
const RecepcionesFletes = (props) => {
    const { recepciones, cambio_dolar } = props;

    // TOTALES
    const [totalesBonificacion, setTotalesBonificacion] = useState({
        total_bonificaciones: 0,
        total_kg: 0,
        total_bonos: 0,
        total_bonos_quetzales: 0,
    });

    useEffect(() => {
        let total_bonificaciones = 0;
        let total_kg = 0;
        let total_bonos = 0;

        recepciones.forEach((item) => {
            const { bono_recibido } = calcularBonoFletes(item);

            if (bono_recibido > 0) {
                total_bonificaciones += 1;
                total_kg += item.movimiento.peso_neto;
                total_bonos += bono_recibido;
            }
        });

        setTotalesBonificacion({
            total_bonificaciones,
            total_kg,
            total_bonos,
            total_bonos_quetzales: total_bonos * cambio_dolar,
        });
    }, [recepciones]);

    return (
        <div className='row'>
            <div className='col-12'>
                <div className='mx-3 my-2 mb-4'>
                    <div className="recepciones-bonificacion-liq">
                        <h4 className='mb-2 text-center'>Bonificación por Transporte</h4>
                        {/* TABLA */}
                        <div className='new-table-wrapper liquidaciones-crear__table-wrapper'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>RECEPCIÓN</th>
                                        <th>FECHA</th>
                                        <th className='th--right'>KG SECOS</th>
                                        <th className='th--right'>PESO NETO</th>
                                        <th className='th--right'>KG MÍNIMOS</th>
                                        <th className='th--right'>BONO POR KG</th>
                                        <th className='th--right th--no-wrap'>BONIFICACIÓN $</th>
                                        <th className='th--right th--no-wrap'>BONIFICACIÓN Q</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* mostrar una fila vacía */}
                                    {recepciones.length === 0 &&
                                        <tr>
                                            <td colSpan='8' className='text-center'>No hay datos para mostrar</td>
                                        </tr>
                                    }
                                    {recepciones.map((item, index) => {
                                        // Bonificación por costo de flete
                                        const {
                                            aplicaBonoFletes,
                                            kg_minimos,
                                            bono_por_kilogramo,
                                            bono_recibido
                                        } = calcularBonoFletes(item);

                                        let ClassColor = '';
                                        if (aplicaBonoFletes && bono_recibido > 0) {
                                            ClassColor = 'text-success font-weight-bold';
                                        } else if (aplicaBonoFletes && bono_recibido <= 0) {
                                            ClassColor = 'text-danger font-weight-bold';
                                        }

                                        return (
                                            <tr key={index}>
                                                <td>{item.movimiento.ingreso.id}</td>
                                                <td>{FormatDate(item.movimiento.ingreso.fecha)}</td>
                                                <td
                                                    label="Kg Secos"
                                                    className='td--right td--no-wrap'>
                                                    {kgValue(item.kilos_secos)}
                                                </td>
                                                <td
                                                    label="Peso Neto"
                                                    className={`td--right td--no-wrap ${ClassColor}`}>
                                                    {kgValue(item.movimiento.peso_neto)}
                                                </td>
                                                <td
                                                    label="Kg Mínimos"
                                                    className='td--right td--no-wrap'>
                                                    {aplicaBonoFletes ? kgValue(kg_minimos) : 'no aplica'}
                                                </td>
                                                <td
                                                    label="Bono por Kg"
                                                    className='td--right td--no-wrap'>
                                                    {aplicaBonoFletes ? currencyValue(bono_por_kilogramo) : 'no aplica'}
                                                </td>
                                                <td
                                                    label="Bonificación $"
                                                    className='td--right td--no-wrap'>
                                                    {aplicaBonoFletes ? currencyValue(bono_recibido) : 'no aplica'}
                                                </td>
                                                <td
                                                    label="Bonificación Q"
                                                    className='td--right td--no-wrap'>
                                                    {aplicaBonoFletes ? currencyValue(bono_recibido * cambio_dolar, false) : 'no aplica'}
                                                </td>
                                            </tr>
                                        )
                                    }
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {/* TOTALES */}
                        <TotalesBonificacion
                            totalesBonificacion={totalesBonificacion}
                        />
                    </div>
                </div>
            </div>
        </div>

    )
};

export default RecepcionesFletes;
